import { cva } from 'class-variance-authority';

export const variants = {
  headingTiny: [
    'font-ref-heading-tiny-font-family',
    'text-font-ref-heading-tiny-font-size',
    'font-ref-heading-tiny-font-weight',
    'leading-font-ref-heading-tiny-line-height',
    'tracking-font-ref-heading-tiny-letter-spacing',
  ],
  headingSmall: [
    'font-ref-heading-small-font-family',
    'text-font-ref-heading-small-font-size',
    'font-ref-heading-small-font-weight',
    'leading-font-ref-heading-small-line-height',
    'tracking-font-ref-heading-small-letter-spacing',
  ],
  headingMedium: [
    'font-ref-heading-medium-font-family',
    'text-font-ref-heading-medium-font-size',
    'font-ref-heading-medium-font-weight',
    'leading-font-ref-heading-medium-line-height',
    'tracking-font-ref-heading-medium-letter-spacing',
  ],
  headingLarge: [
    'font-ref-heading-large-font-family',
    'text-font-ref-heading-large-font-size',
    'font-ref-heading-large-font-weight',
    'leading-font-ref-heading-large-line-height',
    'tracking-font-ref-heading-large-letter-spacing',
  ],
  bodyRegular: [
    'font-ref-body-regular-font-family',
    'text-font-ref-body-regular-font-size',
    'font-ref-body-regular-font-weight',
    'leading-font-ref-body-regular-line-height',
    'tracking-font-ref-body-regular-letter-spacing',
  ],
  bodyMedium: [
    'font-ref-body-medium-font-family',
    'text-font-ref-body-medium-font-size',
    'font-ref-body-medium-font-weight',
    'leading-font-ref-body-medium-line-height',
    'tracking-font-ref-body-medium-letter-spacing',
  ],
  bodyBold: [
    'font-ref-body-bold-font-family',
    'text-font-ref-body-bold-font-size',
    'font-ref-body-bold-font-weight',
    'leading-font-ref-body-bold-line-height',
    'tracking-font-ref-body-bold-letter-spacing',
  ],
  captionRegular: [
    'font-ref-caption-regular-font-family',
    'text-font-ref-caption-regular-font-size',
    'font-ref-caption-regular-font-weight',
    'leading-font-ref-caption-regular-line-height',
    'tracking-font-ref-caption-regular-letter-spacing',
  ],
  captionMedium: [
    'font-ref-caption-medium-font-family',
    'text-font-ref-caption-medium-font-size',
    'font-ref-caption-medium-font-weight',
    'leading-font-ref-caption-medium-line-height',
    'tracking-font-ref-caption-medium-letter-spacing',
  ],
  captionBold: [
    'font-ref-caption-bold-font-family',
    'text-font-ref-caption-bold-font-size',
    'font-ref-caption-bold-font-weight',
    'leading-font-ref-caption-bold-line-height',
    'tracking-font-ref-caption-bold-letter-spacing',
  ],
  displaySmall: [
    'font-ref-display-small-font-family',
    'text-font-ref-display-small-font-size',
    'font-ref-display-small-font-weight',
    'leading-font-ref-display-small-line-height',
    'tracking-font-ref-display-small-letter-spacing',
  ],
  displayMedium: [
    'font-ref-display-medium-font-family',
    'text-font-ref-display-medium-font-size',
    'font-ref-display-medium-font-weight',
    'leading-font-ref-display-medium-line-height',
    'tracking-font-ref-display-medium-letter-spacing',
  ],
  displayLarge: [
    'font-ref-display-large-font-family',
    'text-font-ref-display-large-font-size',
    'font-ref-display-large-font-weight',
    'leading-font-ref-display-large-line-height',
    'tracking-font-ref-display-large-letter-spacing',
  ],
  displayHuge: [
    'font-ref-display-huge-font-family',
    'text-font-ref-display-huge-font-size',
    'font-ref-display-huge-font-weight',
    'leading-font-ref-display-huge-line-height',
    'tracking-font-ref-display-huge-letter-spacing',
  ],
  link: [
    'font-ref-link-link-font-family',
    'text-font-ref-link-link-font-size',
    'font-ref-link-link-font-weight',
    'leading-font-ref-link-link-line-height',
    'tracking-font-ref-link-link-letter-spacing',
    'cursor-pointer',
    'underline',
  ],
  linkStandalone: [
    'font-ref-link-standalone-font-family',
    'text-font-ref-link-standalone-font-size',
    'font-ref-link-standalone-font-weight',
    'leading-font-ref-link-standalone-line-height',
    'tracking-font-ref-link-standalone-letter-spacing',
    'cursor-pointer',
  ],
  // Metric variants carry tabular figures: Inter's proportional `1` is 38% narrower
  // than its `8`, which misaligns numeric columns and makes values that update in
  // place jitter. Keep `tabular-nums` last, the variant test asserts tokens by index.
  metricTiny: [
    'font-ref-metrics-tiny-font-family',
    'text-font-ref-metrics-tiny-font-size',
    'font-ref-metrics-tiny-font-weight',
    'leading-font-ref-metrics-tiny-line-height',
    'tracking-font-ref-metrics-tiny-letter-spacing',
    'tabular-nums',
  ],
  metricSmall: [
    'font-ref-metrics-small-font-family',
    'text-font-ref-metrics-small-font-size',
    'font-ref-metrics-small-font-weight',
    'leading-font-ref-metrics-small-line-height',
    'tracking-font-ref-metrics-small-letter-spacing',
    'tabular-nums',
  ],
  metricMedium: [
    'font-ref-metrics-medium-font-family',
    'text-font-ref-metrics-medium-font-size',
    'font-ref-metrics-medium-font-weight',
    'leading-font-ref-metrics-medium-line-height',
    'tracking-font-ref-metrics-medium-letter-spacing',
    'tabular-nums',
  ],
  metricLarge: [
    'font-ref-metrics-large-font-family',
    'text-font-ref-metrics-large-font-size',
    'font-ref-metrics-large-font-weight',
    'leading-font-ref-metrics-large-line-height',
    'tracking-font-ref-metrics-large-letter-spacing',
    'tabular-nums',
  ],
  metricHuge: [
    'font-ref-metrics-huge-font-family',
    'text-font-ref-metrics-huge-font-size',
    'font-ref-metrics-huge-font-weight',
    'leading-font-ref-metrics-huge-line-height',
    'tracking-font-ref-metrics-huge-letter-spacing',
    'tabular-nums',
  ],
  labelSmall: [
    'font-ref-labels-small-font-family',
    'text-font-ref-labels-small-font-size',
    'font-ref-labels-small-font-weight',
    'leading-font-ref-labels-small-line-height',
    'tracking-font-ref-labels-small-letter-spacing',
  ],
  labelMedium: [
    'font-ref-labels-medium-font-family',
    'text-font-ref-labels-medium-font-size',
    'font-ref-labels-medium-font-weight',
    'leading-font-ref-labels-medium-line-height',
    'tracking-font-ref-labels-medium-letter-spacing',
  ],
  snippetRegular: [
    'font-ref-snippet-medium-regular-font-family',
    'text-font-ref-snippet-medium-regular-font-size',
    'font-ref-snippet-medium-regular-font-weight',
    'leading-font-ref-snippet-medium-regular-line-height',
    'tracking-font-ref-snippet-medium-regular-letter-spacing',
  ],
  snippetMedium: [
    'font-ref-snippet-medium-medium-font-family',
    'text-font-ref-snippet-medium-medium-font-size',
    'font-ref-snippet-medium-medium-font-weight',
    'leading-font-ref-snippet-medium-medium-line-height',
    'tracking-font-ref-snippet-medium-medium-letter-spacing',
  ],
  snippetBold: [
    'font-ref-snippet-medium-bold-font-family',
    'text-font-ref-snippet-medium-bold-font-size',
    'font-ref-snippet-medium-bold-font-weight',
    'leading-font-ref-snippet-medium-bold-line-height',
    'tracking-font-ref-snippet-medium-bold-letter-spacing',
  ],
};

export const textVariants = cva([], {
  variants: {
    variant: variants,
  },
  defaultVariants: {
    variant: 'bodyRegular',
  },
});
